import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import postData from './postData';
import { AgGridReact } from 'ag-grid-react';
import { themeQuartz } from 'ag-grid-community'
import { purpleairStatus, purpleairColor } from './purpleairfunctions';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Box, Typography } from '@mui/material';



const PurpleairWebpageAll = () => {
    //arrays to hold sensor readings
    const [aryRecent, setRecent] = useState(undefined);
    const [retryCount, setRetryCount] = useState(0);

    //warning dialog variables
    const [openWarningDialog, setOpenWarningDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    //  grid variables
    const gridRef = useRef();
    const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);

    function statusValueGetter(params) {
        return purpleairStatus(params.data['pm2.5']);
    }

    function readingValueGetter(params) {
        return params.data['pm2.5'];
    }

    function reading03ValueGetter(params) {
        return params.data['pm25_atm'];
    }
    const formatDate = (params) => {
        return new Date(params.data.databasedatetime).toLocaleString();

    };

    function statusColor(params) {
        let bgcolor = purpleairColor(params.data['pm2.5']);
        return { backgroundColor: bgcolor }
    }


    const columnDefs = [
        { headerName: 'Start', valueGetter: formatDate, width: 270 }
        , { headerName: 'Spike Risk Level', valueGetter: statusValueGetter, cellStyle: statusColor }
        , { headerName: 'Sensor', field: 'sensorname' }
        , { headerName: 'Concentration', valueGetter: readingValueGetter }
        , { headerName: 'Scattering Coefficient', field: 'scattering_coefficient' }
        , { headerName: 'Instantaneous', valueGetter: reading03ValueGetter }
        , { headerName: ' Sensor confidence', field: 'confidence' }
    ]
        ;

    const defaultColDef = {
        sortable: true,
        autoHeight: true,
        resizable: true,
        suppressMovable: true
    };

    const gridTheme = themeQuartz.withParams({
        fontSize: 12
    })


    const popupParent = useMemo(() => {
        return document.body;
    }, []);

    const onBtnExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv();
    }, []);

    const autoSizeStrategy = useMemo(() => ({
        type: 'fitCellContents'
    }), []);

    //-------------------------------------------------------------
    // ----- handle user warning
    useEffect(() => {
        if (errorMessage !== '') {
            setOpenWarningDialog(true);
        }
    }, [errorMessage]
    )
    const handleErrorDialogOK = () => {
        setOpenWarningDialog(false);
        setErrorMessage('');
    };

    //-------------------------------------------------------------  
    // retrieve relevant submissions ------------------------------
    const getRecent = async () => {

        const formData = new FormData();
        formData.append('hours', 0);
        var objEntity = await postData('https://sarasotapublic.com/usrecycling/purpleairWebpageReading.php', formData);
        setErrorMessage(objEntity.theError);
        if (objEntity.theData !== null) {
            setRecent(objEntity.theData);
        } else {
            if (retryCount < 3) {
                // Retry after 3 seconds
                setTimeout(() => setRetryCount(retryCount + 1), 3000);
            } //retry
        } //else 
    }

    useEffect(() => {
        getRecent();
        // eslint-disable-next-line
    }, [retryCount]);


    //-------------------------------------------------------------
    return (
        <>
            <Box display="flex" alignItems="center" gap={10}>
                <Typography variant="h5" gutterBottom>
                    All readings
                </Typography>
                <Button variant='contained' onClick={onBtnExport} >Export</Button>
        <span style={{ fontSize: '0.8em', fontStyle: 'italic' }}>concentration values of PM 2.5 ( µg/m<sub>3</sub> ) taken on a two minute interval
        </span>
            </Box>
            <div id="gridContainer" style={{ height: '70vh', width: '100%', textAlign: 'left' }}>
                <div style={gridStyle} className="ag-theme-alpine">
                    <AgGridReact
                        ref={gridRef}
                        rowData={aryRecent}
                        suppressExcelExport={true}
                        popupParent={popupParent}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        theme={gridTheme}
                        autoSizeStrategy={autoSizeStrategy}
                    />
                </div>
            </div>
            <Dialog
                open={openWarningDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Submission List Error
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {errorMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleErrorDialogOK}>Ok</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PurpleairWebpageAll;